module.exports = __webpack_public_path__ + "images/trello-business-class-with-text.65f97b9241872243c0b9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/trello-business-class-with-text.png
// module id = dZKy
// module chunks = 1